<template lang="pug">
el-dialog(v-dialogDrag :title="title" :visible.sync="dataDialog" width="400px" :before-close="handleClose")
  el-form(ref="form" :model="form" label-width="100px" size="small" label-position="top")
    el-form-item(label="业务模型编号")
      el-input(v-model="form.tableName" readonly)
    el-form-item(label="业务模型名称")
      el-input(v-model="form.businessName" readonly)
    el-form-item(label="备注")
      el-input(v-model="form.tableDesc" type="textarea" :rows="4" readonly)
</template>

<script>
import metadataService from "@/CommonDP/service/metadata-service.js";
export default {
  data () {
    return {
      title: '',
      dataDialog: false,
      form: {}
    };
  },
  methods: {
    // 添加
    async openDialog(metaId, businessName) {
      this.title = businessName + "详情";
      this.dataDialog = true;
      const res = await metadataService.dynMetaDetail(metaId);
      this.form = res.data;
    },
    handleClose() {
      this.dataDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>

